




import { Component, Vue, Prop } from 'vue-property-decorator';
import Dictionary from '@/components/Dictionary.vue';
import { dictionary, DictionaryEntry } from '@/dictionary';

@Component({
  name: 'Category',
  components: {
    Dictionary
  }
})
export default class Category extends Vue {

  @Prop({ default: () => () => true })
  private filter!: (entry: DictionaryEntry) => boolean;

  @Prop({ default: true })
  private displayCategory!: boolean;

  private get dictionary() {
    return dictionary.filter(this.filter);
  }
}  
